<template>
  <div class="make">
    <div  :class="[Number(number)||Number(number)===0?'title_make padding':'title_make']">
      <span class="tit_num" v-if="Number(number)">{{number}}、</span>
      <span class="tit_num" v-else-if="Number(number)===0">{{ask.no}}、</span>
      <span class="title" v-if="ask.question_title" v-html="ask.question_title">{{ask.question_title}}</span>
      <span class="askTitle" v-html="ask.content" v-if="ask.content"></span>
      <!-- <p class="askTitle" v-html="ask.parse" v-if="ask.parse"></p> -->
    </div>
    <div class="contact_blank clearfix" v-if="is_answer">
      <!-- 检查作业个人详情 -->
      <span v-if="!!checked&&answer" :class="[(aind+1)%4===0?'blank margin0':'blank','inspect_myColor']" 
        v-for="(answer,aind) in ask.user_answer" 
        v-html="answer"
        >{{answer}}</span>
      <!-- 检查作业作业预览 -->
      <span v-if="!checked" :class="[(aind+1)%4===0?'blank margin0':'blank','answer']"
            v-for="(answer,aind) in answers" v-html="answer">{{answer}}</span>
    </div>
      <!-- <span :class="[(aind+1)%4===0?'blank margin0':'blank','answer']" -->
    <div class="contact_blank clearfix" v-else>
      <!-- <span :class="[(aind+1)%4===0?'blank margin0':'blank','answer']" -->
      <span class="blank"
            v-for="(answer,aind) in answers" v-html="ask.right_answer[answer]" v-if="ask.right_answer[answer]">{{ask.right_answer[answer]}}</span>
    </div>
    <template v-if="!is_answer">
      <p class="contact_remind" >点击下方单词填充到上方横线</p>
      <div class="contact_words clearfix">
        <!-- <template v-if="type==10"> -->
          <!-- <span class="word" v-for="word in ask.words" v-html="word">{{word}}</span> -->
        <!-- </template> -->
        <!-- <template v-else> -->
          <p class="sentence" v-for="sentence in ask.words" v-html="sentence">{{sentence}}</p>
        <!-- </template> -->
      </div>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
  import loadingS from 'COMPONENTS/base/loadingS.vue';
  import noResouse from 'COMPONENTS/noResouse.vue';

  export default {
    data() {
      return {
        answers: [],
      }
    },
    props: ['ask', 'is_answer', 'type', 'number','checked','myColor'],
    components: {
      loadingS, noResouse
    },
    methods: {},
    created() {
      if(this.ask.user_answer &&!this.ask.is_new && !!this.checked){
        let user_answer_list = [];
        this.ask.user_answer=JSON.parse(this.ask.user_answer);
        this.ask.user_answer.forEach(num=>{
          user_answer_list.push(this.ask.right_answer[num]);
        })
        this.ask.user_answer = user_answer_list;
      }else if(this.ask.user_answer &&this.ask.is_new && !!this.checked){
        this.ask.user_answer = this.ask.user_answer.split('|');
      }
      //this.is_answer:true 正确答案；false 用户答案
      this.answers = this.is_answer ? this.ask.right_answer : this.ask.user_answer;
      // this.answers = this.ask.user_answer;
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "./src/assets/scss/common/_mixin";

  .make {
    padding-bottom: 34px/$ppr;
    .title_make {
      padding:0 24px/$ppr;
      .title {
        display:inline-block;
        padding: 32px/$ppr 0;
        border-top: 1px/$ppr solid #E8E8E8;
        &:first-child {
          border-top: none;
        }
      }
      &.padding {
        position: relative;
        p:first-child {
          padding-left: 80px/$ppr;
        }
        .tit_num {
          display:inline-block;
          // position: absolute;
          // top: 32px/$ppr;
          // left: 24px/$ppr;
          line-height:45px/$ppr;
          width:40px/$ppr;
          // padding:25px/$ppr 0 25px/$ppr 25px/$ppr;
        }
      }
    }
    .contact_blank {
      padding: 20px/$ppr 25px/$ppr 0;
      border-top: 1px/$ppr solid #E8E8E8;
      .blank {
        display:inline-block;
        margin-right:25px/$ppr;
        max-width:100%;
        // display: block;
        padding: 24px/$ppr 24px/$ppr 0;
        border-bottom: 1px/$ppr solid #333;
        box-sizing: border-box;
        &.answer {
          text-align: center;
          font-size: 30px/$ppr;
          color: #66cc22;
          border-bottom: 1px/$ppr solid #66cc22;
        }
        &.inspect_myColor{
          text-align: center;
          font-size: 30px/$ppr;
          color: #5d89ef;
          border-bottom: 1px/$ppr solid #5d89ef;
        }
      }
    }
    .contact_remind {
      margin-top: 60px/$ppr;
      text-align: center;
      font-size: 24px/$ppr;
      color: #ff6600;
    }
    .contact_words {
      padding-right: 24px/$ppr;
      .word {
        display: block;
        float: left;
        margin-left: 24px/$ppr;
        margin-top: 24px/$ppr;
        padding: 0 56px/$ppr;
        height: 72px/$ppr;
        line-height: 72px/$ppr;
        font-size: 30px/$ppr;
        color: #fff;
        background: #5E89EF;
        border-radius: 20px/$ppr;
        box-sizing: border-box;
      }
      .sentence {
        margin: 24px/$ppr 0 0 24px/$ppr;
        padding: 32px/$ppr 24px/$ppr;
        font-size: 30px/$ppr;
        color: #fff;
        background: #5E89EF;
        border-radius: 20px/$ppr;
        word-wrap: break-word;
      }
    }
  }
</style>
